import React, { useState } from "react";
import Image from "next/image";
import HireFromMilesForm from "@/components/forms/hireFromMilesForm";
import HireFromMilesFooter from "./HireFromMilesFooter";

const BrandAndAdvertisingMobileHFM = () => {
  const [isformPopupOpen, setformPopupOpen] = useState(false);

  const openformPopup = () => {
    setformPopupOpen(true);
  };

  const closeformPopup = () => {
    setformPopupOpen(false);
  };
  return (
    <section className="flex flex-col justify-center items-center gap-3 w-full relative bg-no-repeat bg-contain bg-bottom bg-[#061a2f] shadow-[66px_87.333px_30.667px_0px_rgba(4,84,175,0),42.667px_56px_28px_0px_rgba(4,84,175,0.01),24px_31.333px_23.333px_0px_rgba(4,84,175,0.05),10.667px_14px_17.333px_0px_rgba(4,84,175,0.09),2.667px_3.333px_9.333px_0px_rgba(4,84,175,0.1)]">
      <div className="z-50 flex flex-col items-center justify-center rounded-[15.817px] border-[2.26px] border-[#3174d6] bg-white shadow-[111.849px_148.002px_51.97px_0px_rgba(4,84,175,0),72.306px_94.902px_47.451px_0px_rgba(4,84,175,0.01),40.672px_53.1px_39.543px_0px_rgba(4,84,175,0.05),18.077px_23.726px_29.374px_0px_rgba(4,84,175,0.09),4.519px_5.649px_15.817px_0px_rgba(4,84,175,0.1)] w-[300px] mt-14">
        <div className="text-center">
          <h2 className="font-semibold text-[20px] text-black text-center mt-5">
            <span className="leading-[normal]">
              Hire Top Talent in <br></br>{" "}
              <span className="border-[#CA7216] border-b-[4px] pb-[5px]">
                Branding & Advertising
              </span>
            </span>
          </h2>
        </div>

        <div className="flex justify-center items-center mt-16">
          <Image
            loading="lazy"
            src="/hire-from-miles/talent-in-brand.png"
            alt="Hire Accountants in India"
            className=""
            width={364}
            height={364}
          />
        </div>

        <div className="flex flex-col justify-center items-center gap-3">
          <h3 className="text-black text-center leading-4 text-[16px] font-bold">
            Connect With Next-Gen
            <br /> Business Talent
          </h3>
          <p className="text-black text-center text-[14px] leading-4 font-medium">
            Access a dedicated talent pool of
            <br /> <span className="font-bold">Miles SOBA</span> graduates and
            students,
            <br /> ready to propel innovation and
            <br /> growth in your organization.
          </p>

          <div className="flex items-center gap-4 mt-10 mb-5">
            <div
              style={{ borderRadius: "9.038px 9.038px 9.038px 0px" }}
              onClick={openformPopup}
              className="new_btn_branding_hire_from_miles new_btn_hire_graduate hire-from-miles-btn-textual"
            >
              Hire a Graduate
            </div>
            <div
              style={{ borderRadius: "9.038px 9.038px 9.038px 0px" }}
              onClick={openformPopup}
              className="new_btn_branding_hire_from_miles new_btn_hire_intern hire-from-miles-btn-textual"
            >
              Hire an Intern
            </div>
          </div>
        </div>
      </div>
      <div className="w-full relative z-40">
        <HireFromMilesFooter isMobile={true} />
      </div>
      <div className="w-full z-30 relative">
        <Image
          src="/hire-from-miles/miles-blue-logo-footer.svg"
          alt="Special Offer"
          className="absolute bottom-0"
          width={490}
          height={320}
          loading="lazy"
        />
      </div>
      {isformPopupOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999] lg:p-10 p-4">
          <div className="rounded-[14px] shadow-lg relative lg:w-[500px] lg:h-[auto] md:w-[500px] h-[auto] mx-auto w-[365px] bg-white lg:py-6 lg:px-9 p-4">
            <button
              onClick={closeformPopup}
              className="mt-2 text-[#878787] px-3 text-lg py-1 rounded absolute right-[10px] top-[0px] z-[9999]"
            >
              ✕
            </button>
            <HireFromMilesForm />
          </div>
        </div>
      )}
    </section>
  );
};

export default BrandAndAdvertisingMobileHFM;
